import { useState, useEffect } from "react";
import { URL } from "../api";
import axiosInstance from "../Request";
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  Table,
  Container,
  Row,
  Col,
  Input,
  FormGroup,
  Label,
  Badge,
} from "reactstrap";

import { Link } from "react-router-dom";

import Header from "components/Headers/Header.js";
import { isLoggedIn, isFintechUser } from "../util/common.js";
import { useNavigate } from "react-router-dom";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import getPrivilegeList from "../PrivilegeList";
import LeadListComment from "./LeadListComment";

const privilegeList = getPrivilegeList();

const Index = (props) => {
  const navigate = useNavigate();

  const logged = isLoggedIn();
  const [leads, setLeads] = useState([]); // store API data

  const [offset, setOffset] = useState(0);
  const [hasMore, setHasMore] = useState(true); // for optional backend limit
  const [page, setPage] = useState(0); // 0-based page; backend returns 10 per offset
  const PAGE_SIZE = 10;

  const formatDate = (isoString) => {
    if (!isoString) return "N/A";
    const date = new Date(isoString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  };

  const [statusList, setStatusList] = useState({
    customerStatuses: [],
    loanStatuses: [],
  });

  const [lspList, setLspList] = useState([]);

  useEffect(() => {
    if (!logged) {
      navigate("/auth/login");
    } else {
      filterLeads();
      fetchStatusList();
      fetchLspList();
    }
  }, [navigate, logged]);

  const fetchLspList = async () => {
    // Fintech (LSP) logins never see the LSP dropdown, so don't fetch the list for them.
    if (isFintechUser()) return;
    try {
      const response = await axiosInstance.get(URL.LSP_NAMES);
      // Endpoint returns a JSON array; guard against an error object / unexpected shape
      // so the render never hits `lspList.map is not a function`.
      const data = response.data;
      setLspList(Array.isArray(data) ? data : Array.isArray(data?.data) ? data.data : []);
    } catch (error) {
      console.error("Failed to fetch LSP list", error);
    }
  };

  const filterLeads = async (
    offsetValue = 0,
    isLoadMore = false,
    data = formData
  ) => {
    try {
      const response = await axiosInstance.get(URL.DASHBOARD_LEAD_LIST, {
        params: {
          customerId:
            data.searchType === "customerId" ? data.searchValue : null,
          leadId: data.searchType === "leadId" ? data.searchValue : null,
          loanId: data.searchType === "loanId" ? data.searchValue : null,
          loanStatus: data.loan_status || null,
          customerStatus: data.customer_status || null,
          registrationDate: startDate
            ? startDate.toISOString().split("T")[0]
            : null,
          borrowerName:
            data.searchType === "borrowerName" ? data.searchValue : null,
          panNumber:
            data.searchType === "panNumber" ? data.searchValue : null,
          mobileNumber:
            data.searchType === "mobileNumber" ? data.searchValue : null,
          applicationId:
            data.searchType === "applicationId" ? data.searchValue : null,
          fintechId: data.selectedLspId || localStorage.getItem("fintechId") || null,
          offset: offsetValue,
        },
      });

      const newLeads = response.data || [];

      setLeads((prev) => (isLoadMore ? [...prev, ...newLeads] : newLeads));

      setHasMore(newLeads.length === 10);
    } catch (error) {
      console.error("Error applying filter:", error);
    }
  };
  // Page-based navigation (matches the loan-page list: only the table scrolls, Prev / Next paging).
  const goToPage = (p) => {
    if (p < 0) return;
    const newOffset = p * PAGE_SIZE;
    setPage(p);
    setOffset(newOffset);
    filterLeads(newOffset, false);
  };

  const fetchStatusList = async () => {
    try {
      const response = await axiosInstance.get(URL.STATUSES);
      setStatusList(response.data); // It sets both customerStatuses and loanStatuses
    } catch (error) {
      console.error("Failed to fetch statuses", error);
    }
  };

  const [startDate, setStartDate] = useState(null); // instead of new Date()

  const triggerSearch = () => {
    const cleanedSearch = formData.search.trim().replace(/\s+/g, "");
    window.scrollTo({ top: 0, behavior: "smooth" });
    setOffset(0);
    setPage(0);
    setHasMore(false);
    setLeads([]);
    setTimeout(() => {
      filterLeads(0, false, {
        ...formData,
        search: cleanedSearch.toUpperCase(),
      });
    }, 0);
  };

  const [formData, setFormData] = useState({
    search: "",
    loan_status: "",
    customer_status: "",
    searchType: "",
    searchValue: "",
    borrowerName: "",
    panNumber: "",
    mobileNumber: "",
    applicationId: "",
    loanId: "",
    selectedLspId: "",
    // salse_agent: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  return (
    <>
      <Container className="mt--7" fluid>
        <Card className="bg-gradient-default shadow mb-4">
          <CardBody>
            <h6 className="text-uppercase text-light ls-1 mb-1">Salora Capital · NBFC</h6>
            <h2 className="text-white mb-0">Leads</h2>
          </CardBody>
        </Card>
        <Row>
          <Col xl="12">
            <Card className="shadow">
              <CardHeader className="border-0">
                <Row className="align-items-center">
                  <Col xs="6">
                    <h3 className="mb-0">
                      Leads{" "}
                      <Badge color="secondary" pill className="ml-2">
                        {leads.length}
                      </Badge>
                    </h3>
                  </Col>
                  <Col xs="6" className="text-right">
                    <Button color="primary" size="sm" onClick={() => goToPage(page)}>
                      Refresh
                    </Button>
                  </Col>
                </Row>
                <form
                  className="mt-3"
                  onSubmit={(e) => {
                    e.preventDefault();
                    triggerSearch();
                  }}
                >
                  <input type="text" style={{ display: "none" }} />
                  <div className="d-flex align-items-end filter-bar" style={{ gap: "10px" }}>
                  <FormGroup className="mb-0">
                    <Label className="mb-1 small font-weight-bold">Lead Status</Label>
                    <Input type="select" bsSize="sm" id="loan_status" name="loan_status"
                      value={formData.loan_status} onChange={handleChange}>
                      <option value="">--Lead Status--</option>
                      {statusList.loanStatuses &&
                        Object.entries(statusList.loanStatuses).map(([status, id]) => (
                          <option key={id} value={id}>{status}</option>
                        ))}
                    </Input>
                  </FormGroup>
                  <FormGroup className="mb-0">
                    <Label className="mb-1 small font-weight-bold">Customer Status</Label>
                    <Input type="select" bsSize="sm" id="customer_status" name="customer_status"
                      value={formData.customer_status} onChange={handleChange}>
                      <option value="">--Customer Status--</option>
                      {statusList.customerStatuses &&
                        Object.entries(statusList.customerStatuses).map(([status, id]) => (
                          <option key={id} value={id}>{status}</option>
                        ))}
                    </Input>
                  </FormGroup>
                  {/* A fintech (LSP) login is already scoped to its own fintechId, so it never
                      picks an LSP — the filter is for NBFC staff only. */}
                  {privilegeList.lspSelectShow && !isFintechUser() && (
                    <FormGroup className="mb-0">
                      <Label className="mb-1 small font-weight-bold">LSP</Label>
                      <Input type="select" bsSize="sm" id="selectedLspId" name="selectedLspId"
                        value={formData.selectedLspId}
                        onChange={(e) => {
                          const newLspId = e.target.value;
                          const updatedData = { ...formData, selectedLspId: newLspId };
                          setFormData(updatedData);
                          setOffset(0);
                          setPage(0);
                          setHasMore(false);
                          setLeads([]);
                          setTimeout(() => filterLeads(0, false, updatedData), 0);
                        }}>
                        <option value="">--Select LSP--</option>
                        {(Array.isArray(lspList) ? lspList : []).map((lsp) => (
                          <option key={lsp.id} value={lsp.id}>{lsp.name}</option>
                        ))}
                      </Input>
                    </FormGroup>
                  )}
                  <FormGroup className="mb-0">
                    <Label className="mb-1 small font-weight-bold">Search by</Label>
                    <Input type="select" bsSize="sm" name="searchType" value={formData.searchType}
                      onChange={(e) => {
                        handleChange(e);
                        setFormData((prev) => ({ ...prev, searchValue: "" }));
                      }}>
                      <option value="">-- Search By --</option>
                      <option value="borrowerName">Borrower Name</option>
                      <option value="panNumber">PAN Number</option>
                      <option value="mobileNumber">Mobile Number</option>
                      <option value="applicationId">Application ID</option>
                      <option value="customerId">Cust Id</option>
                      <option value="leadId">Lead Id</option>
                      <option value="loanId">Loan Id</option>
                    </Input>
                  </FormGroup>
                  {formData.searchType && (
                    <FormGroup className="mb-0">
                      <Label className="mb-1 small font-weight-bold">Value</Label>
                      <Input bsSize="sm"
                        placeholder={
                          formData.searchType === "borrowerName" ? "Enter Name"
                            : formData.searchType === "panNumber" ? "Enter PAN"
                            : formData.searchType === "mobileNumber" ? "Enter Mobile"
                            : formData.searchType === "customerId" ? "Enter Cust Id"
                            : formData.searchType === "leadId" ? "Enter Lead Id"
                            : formData.searchType === "loanId" ? "Enter Loan Id"
                            : "Enter ID"
                        }
                        type="text" name="searchValue" value={formData.searchValue}
                        onChange={handleChange}
                        onKeyDown={(e) => e.key === "Enter" && triggerSearch()}
                        style={{ textTransform: formData.searchType === "panNumber" ? "uppercase" : "none" }}
                      />
                    </FormGroup>
                  )}
                  <FormGroup className="mb-0">
                    <Label className="mb-1 small font-weight-bold">Registration Date</Label>
                    <DatePicker
                      className="form-control form-control-sm"
                      selected={startDate}
                      onChange={(date) => {
                        if (date) {
                          const adjustedDate = new Date(
                            date.getTime() - date.getTimezoneOffset() * 60000
                          );
                          setStartDate(adjustedDate);
                        } else {
                          setStartDate(null);
                        }
                      }}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          e.preventDefault();
                          triggerSearch();
                        }
                      }}
                      placeholderText="Registration Date"
                      dateFormat="yyyy-MM-dd"
                    />
                  </FormGroup>
                  <Button color="primary" size="sm" type="submit">Search</Button>
                  </div>
                </form>
              </CardHeader>
              <div className="table-scroll">
              <Table className="align-items-center table-flush">
                <thead className="thead-light">
                  <tr>
                    <th scope="col">Product Code</th>
                    {/* <th scope="col">Borrower Name</th> 
                    <th scope="col">PAN Number</th>    */}
                    <th scope="col">LSP</th>
                    <th scope="col">Cust Code</th>
                    <th scope="col">Lead Code</th>
                    <th scope="col">Loan Code</th>
                    <th scope="col">Cust Status</th>
                    <th scope="col">Lead Status</th>
                    {/* <th scope="col">Agent</th> */}
                    <th scope="col">Comment</th>
                    <th scope="col">Reg. Date</th>
                    <th scope="col">Update Date</th>
                  </tr>
                </thead>
                {/* <tbody>
                  {leads.length > 0 ? (
                    leads.map((lead) => (
                      <tr key={lead.id}>
                        <th scope="row">{lead.product_name}</th> */}
                {/* <td>{lead.borrower_name || "N/A"}</td>
                        <td>{lead.pan_number || "N/A"}</td>     */}
                {/* <td>{lead.lsp || "N/A"}</td>
                        {privilegeList.detailShow ? (
                          <td><Link target="_blank" to={`/customer/detail/${lead.customer_id}/${lead.id}`}>{lead.customer_id}</Link></td>
                         ) : ( 
                          <td><Link target="_blank" to={`/customer/loans/${lead.customer_id}/${lead.id}`}>{lead.customer_id}</Link></td>
                        )}
                        {privilegeList.loanTabShow ? (
                           <td><Link target="_blank" to={`/customer/loans/${lead.customer_id}/${lead.id}`}>{lead.id}</Link></td>
                        ) : (
                           <td><Link target="_blank" to={`/customer/detail/${lead.customer_id}/${lead.id}`}>{lead.id}</Link></td>
                        )}
                        {privilegeList.loanTabShow ? (
                          <td><Link target="_blank" to={`/customer/loans/${lead.customer_id}/${lead.id}`}>{lead.loan_id}</Link></td>
                        ) : (
                          <td><Link target="_blank" to={`/customer/detail/${lead.customer_id}/${lead.id}`}>{lead.loan_id}</Link></td>
                        )}
                        <td>{lead.customer_status_value || "N/A"}</td>
                        <td>{lead.loan_status_value || "N/A"}</td> */}
                {/* <td>{lead.salse_agent ??  '-NA-'}</td> */}
                {/* <td style={{ textAlign: "center", paddingLeft: "0.1px" }}> */}
                {/* <div style={{ display: "inline-block" }}> */}
                {/* <div>{lead.utm_source || "N/A"}</div>
                          {privilegeList.commentTabShow && (
                          <div>
                            <LeadListComment
                              customerId={lead.customer_id}
                              loanId={lead.loan_id}
                              leadId={lead.id}
                            />
                          </div>
                          )} */}
                {/* </div> */}
                {/* </td> */}

                {/* <td>{lead.registration_date}</td> */}
                {/* <td>{lead.update_date}</td> */}
                {/* <td>{formatDate(lead.registration_date)}</td>
                        <td>{formatDate(lead.update_date)}</td>

                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="8">No leads found</td>
                    </tr>
                  )}
                </tbody> */}

                <tbody>
                  {leads.length > 0 ? (
                    leads.map((lead) => {
                      // Customers with payment_tran = true open the trimmed
                      // payment-lead full view instead of the standard one.
                      const fullViewBase = lead.payment_tran
                        ? `/payment/full-view/${lead.customer_id}/${lead.id}`
                        : `/customer/full-view/${lead.customer_id}/${lead.id}`;
                      return (
                      <tr key={lead.id}>
                        <th scope="row">{lead.product_name}</th>
                        <td>{lead.lsp || "N/A"}</td>

                        {/* Updated Links to point to Full View */}
                        <td>
                          <Link target="_blank" to={fullViewBase}>
                            {lead.customer_code || lead.customer_id}
                          </Link>
                        </td>
                        <td>
                          <Link target="_blank" to={fullViewBase}>
                            {lead.lead_code || lead.id}
                          </Link>
                        </td>
                        <td>
                          <Link target="_blank" to={fullViewBase}>
                            {lead.loan_code || lead.loan_id}
                          </Link>
                        </td>

                        <td>{lead.customer_status_value || "N/A"}</td>
                        <td>{lead.loan_status_value || "N/A"}</td>
                        <td style={{ textAlign: "center" }}>
                          {privilegeList.commentTabShow && (
                            <LeadListComment
                              customerId={lead.customer_id}
                              loanId={lead.loan_id}
                              leadId={lead.id}
                            />
                          )}
                        </td>
                        <td>{formatDate(lead.registration_date)}</td>
                        <td>{formatDate(lead.update_date)}</td>
                      </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan="10">No leads found</td>
                    </tr>
                  )}
                </tbody>
              </Table>
              </div>
              <div className="d-flex justify-content-between align-items-center px-3 py-3">
                <Button color="secondary" size="sm" outline disabled={page === 0}
                  onClick={() => goToPage(page - 1)}>
                  <i className="fa fa-chevron-left mr-1" /> Prev
                </Button>
                <span className="text-muted small">Page {page + 1}</span>
                <Button color="secondary" size="sm" outline disabled={leads.length < PAGE_SIZE}
                  onClick={() => goToPage(page + 1)}>
                  Next <i className="fa fa-chevron-right ml-1" />
                </Button>
              </div>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default Index;
